/* eslint-disable */
import { useCallback, useEffect } from 'react';
import { connect } from 'react-redux';
import { useLocation, withRouter } from 'react-router';
// import { IconButton } from '@mui/material';
import { Drawer, IconButton, Tooltip } from '@mui/material';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { SearchOutlined, KeyboardDoubleArrowLeft, KeyboardDoubleArrowRight } from '@mui/icons-material';
import { modalActions, navigationActions } from '../../Actions';
import { classes, objectContainsProperty } from '../../Helpers';
import { urls } from '../../Constants';
import styles from './Sidebar.module.scss';
import SidebarItem from './SidebarItem/SidebarItem';
import Logo from '../../Images/resoee.png';
import { NavRequisitesModal } from '../Modals/NavRequisitesModal';
import { useAuth } from '../Auth/Login/auth';
// import HamburgerToCross from '../Icons/HamburgerToCross/HamburgerToCross';

const container = window !== undefined ? window.document.body : undefined;

// /* eslint-disable */
function Sidebar(props) {
	const pathname = useLocation().pathname.slice(urls.EXTENSION.length);
	const {
		// handleNav,
		expandNav,
		collapseNav,
		navState,
		showSidebar,
		sidebarCollapsed,
		toggleNavItemRequisitesModal,
		toggleSearchModal,
		collapseSidebar,
	} = props;
	const history = useHistory();
	const { appConfig = {} } = useAuth();
	const isWynBrands = appConfig?.customerId === 67;

	// Highlight active nav item based on current pathname
	useEffect(() => {
		// Add slight delay to ensure DOM is updated
		setTimeout(() => {
			// Find active nav item element using a more robust approach
			try {
				// First try to find by exact pathname match
				const activeNavItem = document.querySelector(`[data-nav-key="${pathname}"]`);

				if (activeNavItem) {
					// Scroll into view if needed
					activeNavItem.scrollIntoView({ behavior: 'smooth', block: 'center' });
					return;
				}

				// If that fails, try to find by partial match (base URL without parameters)
				const basePath = pathname.split('?')[0];
				const allNavElements = document.querySelectorAll('[data-nav-key]');
				for (const element of allNavElements) {
					const elementPath = element.getAttribute('data-nav-key');
					if (elementPath && elementPath.startsWith(basePath)) {
						element.scrollIntoView({ behavior: 'smooth', block: 'center' });
						return;
					}
				}
			} catch (error) {
				console.warn('Could not find active navigation element to scroll to:', error);
			}
		}, 300);
	}, [pathname, showSidebar]);

	const handleNavClick = useCallback(
		(navKey) => {
			return () => {
				const navItem = navState[navKey];
				if (navItem.expand) {
					collapseNav();
				} else {
					expandNav(navKey);
				}
			};
		},
		[navState]
	);

	const handleEditClick = (navKey, navItem) => {
		toggleNavItemRequisitesModal(true, {
			navKey,
			navItem,
		});
	};

	useEffect(() => {
		Object.keys(navState ?? {})?.forEach((navEleKey) => {
			const navEle = navState?.[navEleKey];
			if (navEleKey === pathname) {
				if (navEle?.requisites?.length) {
					navEle?.requisites?.forEach((reqEle) => {
						if (!reqEle?.value) {
							handleEditClick(navEleKey, navEle);
						}
					});
				}
			} else if (navEle?.submenu?.[pathname]) {
				// const subMenuEle = navEle?.submenu?.[pathname];
				if (navEle?.requisites?.length) {
					navEle?.requisites?.forEach((reqEle) => {
						if (!reqEle?.value) {
							handleEditClick(navEleKey, navEle);
						}
					});
				}
			}
		});
	}, [pathname]);

	const handleGenerableNavClick = (generateLink) => {
		history.push(generateLink);
	};

	const renderNavMenus = (navObj) => {
		const navMenuDOM = Object.keys(navObj).reduce((navItemDOM, navKey) => {
			const navItem = navObj[navKey];
			const isExpandable = objectContainsProperty(navItem, 'submenu');
			const isExpanded = navItem.expand;
			// const isActive =  pathname.indexOf(navKey) > -1;
			const isActive = pathname === navKey || pathname.startsWith(navKey + '/');
			const isDisabled = navItem.disabled;

			if (!isDisabled) {
				navItemDOM.push(
					<li
						className={`${styles['nav-item']} ${isExpanded ? styles.expanded : ''
							}`}
						key={navKey}
					>
						<SidebarItem
							navItem={navItem}
							navKey={navKey}
							key={navKey}
							isExpandable={isExpandable}
							isExpanded={isExpanded}
							isActive={isActive}
							handleClick={handleNavClick(navKey)}
							handleEditClick={handleEditClick}
							handleGenerableNavClick={handleGenerableNavClick}
							isWynBrands={isWynBrands}
						/>
						{objectContainsProperty(navItem, 'submenu') &&
							renderNavMenus(navItem.submenu)}
					</li>
				);
			}
			return navItemDOM;
		}, []);
		return <ul className={styles['nav-list']}>{navMenuDOM}</ul>;
	};

	const toggleSidebar = useCallback(() => {
		// showSidebar is false at the time of opening the sidebari
		// so block scroll along with opening the sidebar
		// if (!showSidebar) {
		// document.body.classList.add(styles['block-scroll']);
		// } else {
		// document.body.classList.remove(styles['block-scroll']);
		// }
		props.toggleSidebar(!showSidebar);
	}, [showSidebar]);

	const handleCollapseSidebar = useCallback(() => {
		collapseSidebar(!sidebarCollapsed);
	}, [sidebarCollapsed, collapseSidebar]);

	const drawer = (isCollapsed = false) => (
		<div
			className={`${styles['sidebar-root']} ${showSidebar ? styles.open : ''} ${isCollapsed ? styles.collapsed : ''}`}
		>
			<div className={styles['logo-container']}>
				{!isCollapsed && <img className={styles['sidebar-logo']} src={Logo} alt='logo' />}
				{!isCollapsed ? (
					<IconButton
						onClick={() => {
							toggleSearchModal(true, {});
						}}
						className={styles.search_tab}
					>
						<SearchOutlined />
						Search Tab
					</IconButton>
				) : (
					<Tooltip title="Search" placement="right">
						<IconButton
							onClick={() => {
								toggleSearchModal(true, {});
							}}
							className={styles.search_tab_collapsed}
						>
							<SearchOutlined />
						</IconButton>
					</Tooltip>
				)}
			</div>
			<div className={styles['sidebar-nav']}>
				{renderNavMenus(navState)}
			</div>
			<div className={styles['collapse-btn-container']}>
				<Tooltip title={isCollapsed ? 'Expand Sidebar' : 'Collapse Sidebar'} placement="right" arrow>
					<div
						onClick={handleCollapseSidebar}
						className={`${styles['collapse-btn']} ${isCollapsed ? styles['collapsed'] : ''}`}
					>
						{isCollapsed ? <KeyboardDoubleArrowRight fontSize="small" /> : <KeyboardDoubleArrowLeft fontSize="small" />}
					</div>
				</Tooltip>
			</div>
		</div>
	);

	return (
		<>
			<NavRequisitesModal />
			{/* Floating toggle button - always visible */}
			<div className={`${styles['floating-toggle']} ${sidebarCollapsed ? styles['visible'] : ''}`}>
				<Tooltip title="Expand Sidebar" placement="right" arrow>
					<div
						onClick={handleCollapseSidebar}
						className={styles['floating-toggle-btn']}
					>
						<KeyboardDoubleArrowRight fontSize="small" />
					</div>
				</Tooltip>
			</div>
			<Drawer
				container={container}
				variant='temporary'
				open={showSidebar}
				onClose={toggleSidebar}
				ModalProps={{
					keepMounted: true, // Better open performance on mobile.
				}}
				className={classes(styles.temporary, styles.drawer)}
			>
				{drawer()}
			</Drawer>
			<Drawer
				variant='permanent'
				className={classes(styles.permanent, styles.drawer, sidebarCollapsed ? styles.drawerCollapsed : '')}
				open
				PaperProps={{
					style: {
						transform: sidebarCollapsed ? 'translateX(-100%)' : 'translateX(0)',
						transition: 'transform 0.3s ease',
						overflow: 'visible',
					}
				}}
			>
				{drawer(sidebarCollapsed)}
			</Drawer>
		</>
	);
}

const mapStateToProps = (state) => {
	const { navState, showSidebar, sidebarCollapsed } = state.navigation;
	return {
		navState,
		showSidebar,
		sidebarCollapsed,
	};
};

const mapDispatchToProps = {
	handleNav: navigationActions.handleNav,
	expandNav: navigationActions.expandNav,
	collapseNav: navigationActions.collapseNav,
	toggleSidebar: navigationActions.toggleSidebar,
	collapseSidebar: navigationActions.collapseSidebar,
	toggleNavItemRequisitesModal: modalActions.toggleNavItemRequisitesModal,
	toggleSearchModal: modalActions.toggleSearchModal,
};

export default withRouter(
	connect(mapStateToProps, mapDispatchToProps)(Sidebar)
);
